import { accessRole } from '../../../../../../helpers/access_role'
import { config } from "../../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from "reactstrap"

import MKIDatatable from '../../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../../helpers/ui/alert'

import Select from '../../../../../../helpers/ui/CustomSelect'

import { AvForm, AvField } from "availity-reactstrap-validation"

import { cancelToken } from "../../../../../../services/adapters/kepegawaian/diklatService"

import DataTableBloc from '../Blocs/IndexBloc'
import apiResponse from '../../../../../../services/apiResponse'

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return ''
};

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    source
    defaultOrder = 'attendance_correction_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            approveUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: 
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    toggleApprovalModal = () => this.setState({ approvalModal: !this.state.approvalModal })
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            employee_uuid : this.props.uuid,
            training_type: this.props.type,
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentDidUpdate(prevProps) {
        if(prevProps.type !== this.props.type) {
            this.loadData()
        }
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel?.unsubscribe()
    }

    columns = [
{
            key: "attendance_correction_employee_nip",
            text: "Nip",
            sortable: true
        },
        {
            key: "attendance_correction_employee_full_name",
            text: "Nama",
            sortable: true
        },
        {
            key: "attendance_correction_date",
            text: "Tanggal Koreksi",
            sortable: true,
            cell: record => {
                return reformatDate(record.attendance_correction_date)
            }
        },
        {
            key: "correction_type_name",
            text: "Jenis Koreksi",
            sortable: true
        },
        {
            key: "attendance_correction_adjustment_type_name",
            text: "Waktu Koreksi",
            sortable: true
        },
        {
            key: "correction_type_categories_name",
            text: "Kategori Alasan",
            sortable: true
        },
        {
            key: "attendance_correction_approval_status",
            text: "Status",
            width: '100',
            sortable: true,
            cell: record => {
                let status = parseInt(record.attendance_correction_approval_status)
                if (status == 1) {
                    status = <label className="badge rounded-pill bg-soft-success font-size-12" >Disetujui</label>
                } else if (status == 2) {
                    status = <label className="badge rounded-pill bg-soft-danger font-size-12" >Ditolak</label>
                } else {
                    status = <label className="badge rounded-pill bg-soft-warning font-size-12" >Menunggu Approval</label>
                }
                return <span> {status} </span>
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 160,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.attendance_correction_id
                return (
                    <Fragment>
                        { record.attendance_correction_approval_status === 0 && 
                            <Fragment>
                                {accessRole('approve') &&
                                    <span>
                                        <button
                                            className="btn btn-success btn-sm"
                                            id={"approve-"+thisId}
                                            onClick={() => {
                                                this.setState({
                                                    approveUuid: record.attendance_correction_uuid
                                                })
                                                this.toggleApprovalModal()
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                            <i className="uil-check"></i>
                                        </button>
                                    </span>
                                }
                            </Fragment>
                        }
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.attendance_correction_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-align-left"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >Detail</Tooltip>
                        </span>
                        { record.attendance_correction_approval_status === 0 &&
                            <Fragment>
                                { accessRole('update') &&
                                    <span>
                                        <button
                                            className="btn btn-warning btn-sm"
                                            id={"update-" + thisId}
                                            onClick={() => {
                                                this.setState({
                                                    updateUuid: record.attendance_correction_uuid
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                                <i className="uil-pen"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["update" + thisId] : !this.state["update" + thisId]
                                                })
                                            }}
                                        >Perbaharui</Tooltip>
                                    </span>
                                }
                                { accessRole('delete') &&
                                    <span>
                                        <button 
                                            className="btn btn-danger btn-sm" 
                                            id={"delete-" + thisId}
                                            onClick={() => {
                                                this.setState({
                                                    inactiveUuid: record.attendance_correction_uuid,
                                                    confirm: true
                                                })
                                            }}
                                            style={{
                                                padding: '2px 5px'
                                            }}>
                                            <i className="uil-trash-alt"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["delete" + thisId] : !this.state["delete" + thisId]
                                                })
                                            }}
                                        >Nonaktifkan</Tooltip>
                                    </span>
                                }
                            </Fragment>                        
                        }
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    <Redirect to={`/izinpegawai/koreksikehadiran.html?detail&uuid=${this.state.detailUuid}`}/>
                : null }
                { this.state.updateUuid !== null ?
                    <Redirect to={`/izinpegawai/koreksikehadiran.html?update&uuid=${this.state.updateUuid}`}/>
                : null }
                { this.state.approveUuid !== null &&
                    <Redirect to={`/izinpegawai/koreksikehadiran.html?approve&uuid=${this.state.approveUuid}`} />
                }
            </>
        )
    }

}

export default TableActiveComponent